module.exports = __webpack_public_path__ + "img/check.f03af3e3.svg";